<script lang="ts">
  export let cutoffTime: string;

  const parseCutoffTime = (
    cutoffDateTime = "",
    options: any = { hour: "numeric", minute: "numeric" }
  ) => {
    if (!!cutoffDateTime) {
      return new Date(cutoffDateTime).toLocaleString(undefined, options);
    } else {
      return null;
    }
  };

  let formattedCutoffTime = parseCutoffTime(cutoffTime).replace(/\:00\ /g, "");
  let displayText = `${formattedCutoffTime} cutoff`;

</script>

<span class="fizz-inline-4">
  {displayText}
</span>
